import React from 'react';
import { getBookingPrecision } from '@clubmed/domains-service';
import { ICONS } from 'Components/utils/icon/icons';
import { useAppContext } from 'Context/ReactAppContext';
import { formatAmountForLocale } from 'Utils/currency-config-for-locale/currencyConfigForLocale';
import { updateBookingCart } from 'Components/widgets/cart/cart.actions';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
type Props = {
  insurance: {
    id: string;
    label: string;
  };
  price: number;
  bookingId: string;
  updateCart: typeof updateBookingCart;
  iconLabel: string;
  stayIndex: number;
  isCartLocked?: boolean;
};
export const InsuranceService = ({
  insurance,
  price,
  bookingId,
  updateCart,
  iconLabel,
  stayIndex,
  isCartLocked = false,
}: Props) => {
  const appContext = useAppContext();
  const { trackClickEvent } = useTrackEvent();

  const removeFromCart = () => {
    trackClickEvent(TRACK_EVENT_NAMES.CLICK_CART, {
      detail_click: 'remove_insurance',
    });
    updateCart({
      id: insurance.id,
      bookingId,
      context: appContext,
      action: 'remove',
      serviceName: 'INSURANCE',
      stayIndex,
    });
  };

  return (
    <Capsule className="mt-20" contentClassName="flex gap-10 items-start p-10">
      <Icon className="text-sienna" name={ICONS.INSURANCE} width="2rem" />
      <div className="flex-1">
        <p className="text-12 font-bold text-sienna">{iconLabel}</p>
        <div className="flex justify-between gap-10 text-14">
          {insurance.label}
          <div className="flex items-center gap-10">
            {formatAmountForLocale(price, appContext.locale, undefined, {
              precision: getBookingPrecision(appContext.locale),
            })}
            {!isCartLocked && (
              <button className="leaading-0" onClick={removeFromCart} type="button">
                <Icon name={ICONS.CROSS} width="0.8rem" />
              </button>
            )}
          </div>
        </div>
      </div>
    </Capsule>
  );
};
